import { render } from "./ServicePageSvg.vue?vue&type=template&id=1dddb9f9"
import script from "./ServicePageSvg.vue?vue&type=script&lang=js"
export * from "./ServicePageSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__